/**
 * @name Header - Logo component
 *
 * @version 1.0.0
 * @author Christopher Martin
 */

import { h } from "preact";
import { useCallback, useEffect } from "preact/hooks";
import { Link } from "react-router-dom";
import { animated, useSpring } from "react-spring";

export interface IHeaderLogo {
  delay: number;
  href: string;
  label: string;
  show: boolean;
}

const HeaderLogo: preact.FunctionalComponent<IHeaderLogo> = ({
  delay,
  href,
  label,
  show = false
}) => {
  const [props, set] = useSpring(() => ({
    opacity: 0,
    transform: "scale3d(1.2, 1.2, 1.2)"
  }));

  const clickHandler = useCallback(() => {
    set({
      transform: "scale3d(1.2, 1.2, 1.2)"
    });
    set({
      transform: "scale3d(1, 1, 1)",
      delay: 200
    });
  }, []);

  useEffect(() => {
    set({
      opacity: show ? 1 : 0,
      transform: show ? "scale3d(1, 1, 1)" : "scale3d(1.2, 1.2, 1)",
      delay
    });
  }, [show]);

  return (
    <animated.div className="header-logo" style={props}>
      <Link to={href} aria-label={label} onClick={clickHandler}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64"
          viewBox="0 0 64 64"
        >
          <path
            fill-rule="evenodd"
            d="M46.7383514,42.8891073 C47.2285714,31.8448274 52.9409071,9.39277435 59.8416548,3.08870109 C60.9308556,2.09384944 56.1427225,0.809999454 53.3743592,4.20454108 C51.5116294,6.48905438 48.3129973,13.8217926 47.4269937,17.2004842 C47.4031194,13.3114226 49.6849765,6.75005105 51.9519785,4.16068941 C49.9454722,3.96520608 47.585095,6.14193939 46.3096742,8.30335103 C43.4935622,13.0731443 41.8881449,21.6627875 40.8334293,26.7104841 C39.7039073,30.2281274 36.3105666,33.8276624 33.2360811,35.396284 C33.6053377,28.1353991 34.1836275,19.6445542 37.2146086,14.8932526 C38.1175895,13.476791 38.2725075,11.267301 33.7650306,11.386176 C22.249106,11.6894393 13.4055169,17.4260826 5.69357186,14.9888809 C5.3969994,14.8948376 4.96938329,15.0823959 4.72692602,15.3106359 C4.48446875,15.5383476 4.22715633,16.1686493 4.14226976,16.4819509 C3.48439883,18.9122842 5.19380217,21.0150509 7.503778,21.2982375 C10.62389,21.6818075 17.7002469,20.9151959 22.6708862,18.7923526 C19.4871092,21.5840659 12.1927,23.2858275 7.6937117,22.6819425 C9.3134536,28.4085474 21.4458669,24.7672742 25.1925479,23.0702675 C25.5909843,20.6003092 27.3980071,16.3297909 30.2273827,15.2895026 C26.8165341,18.2476409 26.3098674,25.4979591 26.0308028,29.7272674 C25.9252251,31.3233624 26.0254974,35.599164 25.9422024,38.404614 C15.7552833,42.6719623 12.1009164,49.0156605 12.4330351,55.7534954 C12.7683371,62.551032 21.8724219,63.977532 27.1672218,59.1601887 C31.3871455,55.3197338 32.588821,48.0974172 32.8721299,43.6372272 C30.4862867,44.1851089 27.674419,45.2586822 25.5013228,46.5916672 C25.0402826,51.8676038 24.1054692,56.2348071 21.6655109,56.7097787 C20.5757795,56.9221687 19.0568404,55.9056554 18.8605402,54.5071571 C18.2753534,50.3507588 20.4001704,47.1326805 25.6859511,44.0746872 C30.5112222,41.6454106 34.7210656,41.2026673 39.0921935,37.7061573 C38.898546,39.6414423 38.8847519,42.0833989 38.8847519,43.8480322 C38.8847519,49.0795888 39.4720609,53.8187388 41.6101414,56.9200554 C45.2448783,62.192822 51.6692001,60.2665187 53.8263801,56.1095921 C55.0508689,53.7500555 54.0417798,52.8429071 52.4591758,53.8372305 C50.3104845,55.1865938 47.8355104,55.4666104 47.2349379,52.4767721 C46.7059884,49.8456722 46.5744142,46.5943089 46.7383514,42.8891073"
          />
        </svg>
      </Link>
    </animated.div>
  );
};

export default HeaderLogo;
